import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { RouterModule } from '@angular/router';
import { ParseLinks } from 'ng-jhipster';

import { DeviceConfigurerServiceSharedModule } from '../shared';

import {
    adminState,
    AuditsComponent,
    UserMgmtComponent,
    UserDialogComponent,
    UserDeleteDialogComponent,
    UserMgmtDetailComponent,
    UserMgmtDialogComponent,
    UserMgmtDeleteDialogComponent,
    LogsComponent,
    DcsMetricsMonitoringModalComponent,
    DcsMetricsMonitoringComponent,
    DcsHealthModalComponent,
    DcsHealthCheckComponent,
    DcsConfigurationComponent,
    DcsDocsComponent,
    AuditsService,
    DcsConfigurationService,
    DcsHealthService,
    DcsMetricsService,
    LogsService,
    UserResolvePagingParams,
    UserResolve,
    UserModalService
} from './';


@NgModule({
    imports: [
        DeviceConfigurerServiceSharedModule,
        RouterModule.forRoot(adminState, { useHash: true })
    ],
    declarations: [
        AuditsComponent,
        UserMgmtComponent,
        UserDialogComponent,
        UserDeleteDialogComponent,
        UserMgmtDetailComponent,
        UserMgmtDialogComponent,
        UserMgmtDeleteDialogComponent,
        LogsComponent,
        DcsConfigurationComponent,
        DcsHealthCheckComponent,
        DcsHealthModalComponent,
        DcsDocsComponent,
        DcsMetricsMonitoringComponent,
        DcsMetricsMonitoringModalComponent
    ],
    entryComponents: [
        UserMgmtDialogComponent,
        UserMgmtDeleteDialogComponent,
        DcsHealthModalComponent,
        DcsMetricsMonitoringModalComponent,
    ],
    providers: [
        AuditsService,
        DcsConfigurationService,
        DcsHealthService,
        DcsMetricsService,
        LogsService,
        UserResolvePagingParams,
        UserResolve,
        UserModalService
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class DeviceConfigurerServiceAdminModule {}



// WEBPACK FOOTER //
// ./src/main/webapp/app/admin/admin.module.ts